<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('regulation-policies')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">
        Edit Regulation Policies & Papers
      </h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <!-- <b-form-group label="Description">
          <quill-editor
            v-model="description"
            :options="editorOption"
            class="quill-h200px my-2 z-50 relative"
          />
        </b-form-group> -->
        <p class="mb-1">Title</p>
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Write Title here"
          v-model="title"
        >
        </base-input>
        <p class="mb-1">Description</p>
        <base-input
          alternative
          class="mb-3"
          name="description"
          :rules="{ required: true }"
          placeholder="Write Description here"
          v-model="description"
          :maxlength="500"
          @input="limitDescription"
        >
        </base-input>
        <p>
          only this much Characters are allowed
          {{ description.length }} / 500
        </p>
        <br />
        <!-- **Radio Buttons for Selection** -->
        <b-form-group label="Choose Upload Type">
          <b-form-radio-group
            v-model="uploadType"
            class="d-flex"
            @change="clearFields"
          >
            <b-form-radio value="file" class="mr-3">Upload File</b-form-radio>
            <b-form-radio value="link">Enter Link</b-form-radio>
          </b-form-radio-group>
        </b-form-group>

        <!-- **File Upload (Shown when 'Upload File' is selected)** -->
        <div v-if="uploadType === 'file'">
          <p>Attach your files</p>
          <b-form-file
            v-model="file1"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            accept=".pdf"
            @input="validateFile"
          ></b-form-file>
          <div v-if="file1">
            <p class="text-success">Uploaded File:</p>
            <a :href="filePreviewUrl" target="_blank" class="text-blue-500">
              View Uploaded File
            </a>
            <div class="mt-2">
              <base-button type="danger" class="px-4" @click="removeFile">
                Remove PDF
              </base-button>
            </div>
          </div>
        </div>

        <!-- **Link Input (Shown when 'Enter Link' is selected)** -->
        <div v-if="uploadType === 'link'">
          <p>Redirect Link ( Prefix this link with' https:// ' )</p>
          <base-input
            class="mb-3"
            name="Link"
            placeholder="https://www.example.com"
            v-model="link"
          />
        </div>
        <b-form-group
          label="Friends Update image (max size 5MB and Dimensions should H-700, W-900)"
        >
          <FileUploader
            v-show="!coverImage"
            :image="image"
            :onSuccess="handleSuccess"
          />
          <Cropper
            class="cropper"
            :src="image"
            v-if="coverImage != ''"
            @change="handleCropperChange"
            ref="cropper"
            :stencil-props="{
              aspectRatio: 2 / 1,
            }"
          />

          <div v-if="image">
            <p class="mt-2">Image Preview</p>

            <img v-if="image" :src="cropperImg" ref="cover" />
            <div class="flex cursor-pointer items-center my-2" v-if="image">
              <base-button type="danger" class="px-8" @click="handleRemove">
                Remove image
              </base-button>
            </div>
          </div>
          <span v-if="imageErr" class="flex justify-center small text-danger">{{
            msg.image
          }}</span>

          <div class="mt-3 mb-4">
            <p class="mb-2">Uploaded Image</p>
            <img
              class="w-1/2"
              :src="$imageURL + '/' + image2"
              alt="uploaded-image"
            />

            <base-button
              v-if="image2"
              type="danger"
              class="px-8"
              @click="handleRemove"
            >
              Remove image
            </base-button>
          </div>
        </b-form-group>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Update</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";
import "vue-advanced-cropper/dist/style.css";
import { Cropper } from "vue-advanced-cropper";
export default {
  components: {
    FileUploader,
    quillEditor,
    Cropper,
  },
  data() {
    return {
      title: "",
      link: "",
      uploadType: "file",
      image: null,
      image2: "",
      file1: null,
      filePreviewUrl: "",
      fileError: false,
      fileErrorMessage: "",
      coverImage: "",
      cropperImg: "",
      description: "",
      imageErr: false,
      editorOption: {
        theme: "snow",
      },
    };
  },
  methods: {
    limitDescription(event) {
      if (this.description.length > 500) {
        this.description = this.description.substring(0, 500);
      }
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    handleCropperChange(img) {
      this.cropperImg = this.$refs.cropper.getResult().canvas.toDataURL();
      this.coverImage = this.dataURLtoFile(img.canvas.toDataURL(), "image.png");
    },

    handleSuccess(image) {
      console.log(image);

      this.imageErr = false;

      if (!image.type.startsWith("image/")) {
        this.$swal.fire({
          title: "Invalid File",
          text: "Please upload an image file only!",
          // html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          icon: "error",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          text: "Please ensure that the file size does not exceed 5MB",
          icon: "warning",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      this.coverImage = image;
      this.readerData(image);
    },

    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },

    validateFile(file) {
      this.fileError = false;
      this.fileErrorMessage = "";

      if (!file) {
        this.file1 = null;
        this.filePreviewUrl = "";
        return;
      }

      if (!file.type.includes("pdf")) {
        this.fileError = true;
        this.fileErrorMessage = "Only PDF files are allowed!";
        this.file1 = null;
        this.filePreviewUrl = "";
        return;
      }

      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        this.fileError = true;
        this.fileErrorMessage =
          "File size exceeds 10MB! Please upload a smaller file.";
        this.file1 = null;
        this.filePreviewUrl = "";
        return;
      }

      this.file1 = file;
      this.filePreviewUrl = URL.createObjectURL(file);
    },
    removeFile() {
      this.file1 = null;
      this.filePreviewUrl = "";
    },
    clearFields() {
      if (this.uploadType === "file") {
        this.link = "";
      } else {
        this.file1 = null;
        this.filePreviewUrl = "";
      }
    },
    async onSubmit() {
      let Regex = /^(https?:\/\/)?([a-z0-9-]+\.)+[a-z0-9-]{2,6}(\/[^\s]*)?$/i;
      if (this.uploadType === "link" && !Regex.test(this.link.trim())) {
        this.$notify.error({
          message: "Please Enter Valid URL",
          position: "top-right",
        });
        return false;
      }
      if (this.uploadType === "file" && this.fileError) {
        this.$swal.fire({
          title: "Invalid File",
          text: this.fileErrorMessage,
          icon: "warning",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      if (!this.file1 && !this.link) {
        this.$swal.fire({
          title: "File or Link field is Missing",
          text: "Please upload a valid PDF file or Add Link.",
          icon: "warning",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }
      if (!this.coverImage && !this.image2) {
        this.$notify.error({
          message: "Please Select Image",
          position: "top-right",
        });
        loader.close();
        return;
      }
      let FormData = require("form-data");
      let data = new FormData();

      data.append("id", this.selectedregulationspolicy._id);
      data.append("uploadType", this.uploadType);
      if (this.uploadType === "file" && this.file1) {
        data.append("file", this.file1);
      } else if (this.uploadType === "link" && this.link.trim()) {
        data.append("link", this.link.trim());
      }
      if (this.title) data.append("title", this.title);
      if (this.description) data.append("description", this.description.trim());
      if (this.coverImage) {
        data.append("image", this.coverImage);
      } else if (this.image2) {
        data.append("image", this.image2);
      }
      let loader = this.$loading();

      try {
        const newsdata = await this.$store.dispatch(
          "regulationPolicy/editRegulations",
          data
        );

        if (newsdata.code == 200) {
          this.$router.push({ name: "regulation-policies" });
          this.$swal.fire({
            text: "Data Successfully Updated",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        loader.close();
      } catch (error) {
        if (error.response.status) {
          this.$swal.fire({
            title: "Error",
            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
      }
    },
    // init() {
    //   const filePath = this.selectedregulationspolicy.file;
    //   this.file1 = null;
    //   this.filePreviewUrl = "";
    //   if (filePath) {
    //     const fileName = filePath.split("/").pop();
    //     const fileUrl = `${this.$imageURL}/${filePath}`;
    //     this.filePreviewUrl = fileUrl;

    //     fetch(fileUrl)
    //       .then((response) => response.blob())
    //       .then((blob) => {
    //         this.file1 = new File([blob], fileName, {
    //           type: "application/pdf",
    //         });
    //       })
    //       .catch((error) => {
    //         console.error("Error fetching file:", error);
    //       });
    //     console.log("filename", fileName);
    //   }
    //   //  this.file1 = this.selectedregulationspolicy.file;
    //   this.link = this.selectedregulationspolicy.link;
    //   this.image2 = this.selectedregulationspolicy.image;
    //   this.description = this.selectedregulationspolicy.description;
    //   console.log("decription1234", filePath);
    // },
    init() {
      const filePath = this.selectedregulationspolicy.file;
      this.file1 = null;
      this.filePreviewUrl = "";
      this.link = this.selectedregulationspolicy.link;
      this.image2 = this.selectedregulationspolicy.image;
      this.description = this.selectedregulationspolicy.description;
      this.title = this.selectedregulationspolicy.title;

      if (filePath) {
        this.uploadType = "file";
        const fileUrl = `${this.$imageURL}/${filePath}`;
        this.filePreviewUrl = fileUrl;

        fetch(fileUrl)
          .then((response) => response.blob())
          .then((blob) => {
            const fileName = filePath.split("/").pop();
            this.file1 = new File([blob], fileName, {
              type: "application/pdf",
            });
          })
          .catch((error) => console.error("Error fetching file:", error));
      } else if (this.link) {
        this.uploadType = "link";
      }
    },

    handleRemove() {
      this.image = null;
      this.image2 = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  computed: {
    ...mapState("regulationPolicy", {
      selectedregulationspolicy: "selectedregulationspolicy",
    }),
  },
  async mounted() {
    this.init();
    // console.log("selectedregulationspolicy", this.selectedregulationspolicy);
  },
};
</script>
